import useJBLWebSocketCore from "./useJBLWebSocketCore"

const useJBLWebSocket = () => {
  const authStore = useAuthStore()
  const { isLogin } = storeToRefs(authStore)

  const webSiteInfoStore = useWebsiteInfoStore()
  const {
    defaultChangeLines,
    loginedChangeLines,
    state: websiteInfo
  } = storeToRefs(webSiteInfoStore)

  const ENABLE_JBL_INTELLIGENT_CHANGE_LINE = computed(
    () => websiteInfo.value.enableJblIntelligentChangeLine
  )

  const originAPIUrl = computed(
    () => `${window.location.protocol}//${window.location.host}`
  )

  const {
    shouldLoadJBLScript,
    hasMountedJBL,
    loadJBLScript,
    initJBLWebSocket,
    fetchRecommendLine
  } = useJBLWebSocketCore({
    isLogin,
    defaultChangeLines,
    loginedChangeLines,
    ENABLE_JBL_INTELLIGENT_CHANGE_LINE,
    originAPIUrl
  })

  return {
    shouldLoadJBLScript,
    hasMountedJBL,
    loadJBLScript,
    initJBLWebSocket,
    fetchRecommendLine
  }
}

export default useJBLWebSocket
